import { supabase } from './supabase';

// A small, deliberate set of funnel events — see the check constraint in
// the funnel_events migration for the full list. Fire-and-forget: never
// awaited by callers, never blocks UX, swallows its own errors. Losing an
// occasional event is fine; losing a chat message or a star is not, which
// is why this doesn't go through the offline-queued syncMutation path.
export function trackEvent(eventName, metadata = {}, userId = null) {
  supabase
    .from('funnel_events')
    .insert({ event_name: eventName, metadata, user_id: userId })
    .then(({ error }) => {
      if (error) console.warn('[SacredMothr] trackEvent failed:', eventName, error);
    });
}
